<template>
  <div v-if="applicationData" class="container">
    <div id="myModal" class="modal">
      <div class="modal-content">
        <h2>Application Information</h2>
        <div>
          <table class="appInfo-table">
            <tbody>
              <tr>
                <th>Title:</th>
                <td>
                  {{ applicationData.title }}
                </td>
              </tr>
              <tr>
                <th>Subtitle:</th>
                <td>
                  {{ applicationData.subtitle }}
                </td>
              </tr>
              <tr>
                <th>Info:</th>
                <td>
                  {{ applicationData.info }}
                </td>
              </tr>
              <tr>
                <th>Classification:</th>
                <td>
                  {{ applicationData.classification }}
                </td>
              </tr>
            </tbody>
          </table>
          <div v-for="(item, index) in questionsData" :key="index">
            <button class="accordion" @click="e => manageAccordion(e)">{{ item.question }}</button>
            <div class="panel">
              <table class="questionInfo-table">
                <thead>
                  <tr>
                    <th>Designation</th>
                    <th>Name</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Area</td>
                    <td>
                      {{ item.area }}
                    </td>
                    <td>
                      {{ item.area_description }}
                    </td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td>
                      {{ item.type }}
                    </td>
                    <td>
                      {{ item.type_description }}
                    </td>
                  </tr>
                  <tr>
                    <td>Category</td>
                    <td>
                      {{ item.category }}
                    </td>
                    <td>
                      {{ item.category_description }}
                    </td>
                  </tr>
                  <tr>
                    <td>SubCategory</td>
                    <td>
                      {{ item.sub_category }}
                    </td>
                    <td>
                      {{ item.sub_category_description }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <button @click="closeModal" style="margin-top: 1rem;">Close</button>
      </div>
    </div>
    <div class="clone-box card-band-styling">
      <button @click="openModal">Application Info</button>
      <h2>Clone App</h2>
      <table>
        <tbody>
          <tr>
            <th>New Title:</th>
            <td>
              <input type="text" v-model="inputsObject.newTitle">
            </td>
          </tr>
          <tr>
            <th>New Subtitle:</th>
            <td>
              <input type="text" v-model="inputsObject.newSubTitle">
            </td>
          </tr>
          <tr>
            <th>New Custom ID:</th>
            <td>
              <input type="text" v-model="inputsObject.newCustomID">
            </td>
          </tr>
        </tbody>
      </table>
      <div style="text-align: center;">
        <button @click="cloneApp">Clone Application</button>
      </div>
    </div>
  </div>



</template>

<script>
  import instance from "../axios.js";
  import { v4 as uuidv4 } from 'uuid';

  export default {
    data() {
      return {
        applicationID: null,
        applicationData: null,
        questionsData: null,
        inputsObject: {
          newTitle: '',
          newSubTitle: '',
          newCustomID: '',
        }
      }
    },
    async created() {
      try {
        this.getQueryParams();
        let applicationResponse = await instance.get(`/api/appAdmin/application/${this.applicationID}`);
        this.applicationData = {...applicationResponse.data};
        this.inputsObject.newTitle = applicationResponse.data.title;
        this.inputsObject.newSubTitle = applicationResponse.data.subtitle;
        this.inputsObject.newCustomID = applicationResponse.data.application_custom_id;

        let questionResponse = await instance.get(`/api/question-admin/application/${this.applicationID}`);
        this.questionsData = [...questionResponse.data];
        

      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      openModal() {
        document.getElementById('myModal').style.display = 'flex';
      },
      closeModal() {
        document.getElementById('myModal').style.display = 'none';
      },
      getQueryParams() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
          params[key] = value;
        }
        this.applicationID = params.application_id;
      },
      manageAccordion(e) {
        let ref = e.target;
        ref.classList.toggle("active");
        let panel = ref.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        } 
      },
      base64ToFile(base64String, filename) {
        const mimeType = base64String.split(';')[0].split(':')[1];
        const base64Data = base64String.split(',')[1];
        const binaryString = window.atob(base64Data);
        const byteArray = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          byteArray[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: mimeType });
        const file = new File([blob], filename, { type: mimeType });
        return file;
      },
      async cloneApp() {
        try {
          const formData = new FormData();
          let allQuestions = [];
          let new_app_id = uuidv4();

          await instance.post('/api/appAdmin', {
            ...this.applicationData,
            "application_id": new_app_id,
            "application_custom_id": this.inputsObject.newCustomID,
            "owner_uuid": this.$store.getters.getCurrentUser,
            "title":this.inputsObject.newTitle, 
            "subtitle":this.inputsObject.newSubTitle,
            "published": false
          })

          this.questionsData.forEach((question, questionIndex) => {
            let editedchild_buttons = [];
            Array.from(question.child_buttons).forEach((button) => {
              let uniqueName = '';
              if (button.fileRef) {
                uniqueName = `${button.file.Filename}`;
                formData.append(uniqueName, this.base64ToFile(button.fileRef, uniqueName), uniqueName);
              } else {
                if (button.file != null && button.file != "") {
                  uniqueName = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}_${button.file.Filename}`;
                  formData.append(uniqueName, button.file, uniqueName);
                } else {
                  uniqueName = "";
                }
              }
              editedchild_buttons.push({
                ...button,
                file: null,
                fileRef: uniqueName,
                x: parseInt(button.x),
                y: parseInt(button.y),
                width: parseInt(button.width),
                height: parseInt(button.height),
                fontSize: parseInt(button.fontSize),
                zIndex: parseInt(button.zIndex)
              })
            });
            let editedchild_images = [];
            Array.from(question.child_images).forEach((image) => {
              let uniqueName = '';
              if (image.fileRef) {
                uniqueName = `${image.file.Filename}`;
                formData.append(uniqueName, this.base64ToFile(image.fileRef, uniqueName), uniqueName);
              } else {
                if (image.file != null && image.file != "") {
                  uniqueName = `${Date.now()}_${Math.random().toString(36).slice(2, 7)}_${image.file.name}`;
                  formData.append(uniqueName, image.file, uniqueName);
                } else {
                  uniqueName = "";
                }
              }
              editedchild_images.push({
                ...image,
                file: null,
                fileRef: uniqueName,
                x: parseInt(image.x),
                y: parseInt(image.y),
                width: parseInt(image.width),
                height: parseInt(image.height),
                zIndex: parseInt(image.zIndex)
              })
            });

            allQuestions.push({
              "application_id": new_app_id,
              "question_id": uuidv4(),
              "custom_id": question.custom_id,
              "question": question.question,
              "question_description": question.question_description,
              "question_order": questionIndex,
              "area": question.area,
              "area_description": question.area_description,
              "type": question.type,
              "type_description": question.type_description,
              "category": question.category,
              "category_description": question.category_description,
              "sub_category": question.sub_category,
              "sub_category_description": question.sub_category_description,
              "background_color": question.background_color,
              "procedure": question.procedure,
              "age_group": question.age_group,
              "specialist_prompt": question.specialist_prompt,
              "child_buttons": editedchild_buttons,
              "specialist_buttons": JSON.stringify(question.specialist_buttons),
              "child_images": editedchild_images,
              "child_view_original_screen_resolution": question.child_view_original_screen_resolution,
              "highest_score_possible": parseInt(question.highest_score_possible),
              "TTS_child_prompts": question.tts_child_prompts,
              "time_out": question.time_out.toString(),
              "typical_duration": question.typical_duration.toString(),
              "note": question.note
            })
          })
          formData.append("applicationID", this.applicationID)
          formData.append("dataStructure", JSON.stringify(allQuestions));
          await instance.put('/api/question-admin/application/questions', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

          alert('Data Cloned');
          this.$router.push(`/rolesPage/SearchAppAdminApps/viewAppAdminApps/newAppCard/${new_app_id}`);
        } catch (e) {
          alert('Error Data not Cloned');
          console.error(e);
        }
      },
/*       async cloneApp() {
        try {
          let new_app_id = uuidv4();
          await instance.post('/api/appAdmin', {
            ...this.applicationData,
            "application_id": new_app_id,
            "application_custom_id": this.inputsObject.newCustomID,
            "owner_uuid": this.$store.getters.getCurrentUser,
            "title":this.inputsObject.newTitle, 
            "subtitle":this.inputsObject.newSubTitle,
            "published": false
          })
          for (let i = 0; i < this.questionsData.length; i++) {
            let question_id = uuidv4();
            let question = this.questionsData[i];
            question.question_id = question_id;
            question.application_id = new_app_id;
          }
          await instance.post(`/api/question-admin/questions`, this.questionsData);
          this.$router.push(`/rolesPage/SearchAppAdminApps/viewAppAdminApps/newAppCard/${new_app_id}`);
        } catch (err) {
          console.error(err);
        }
      } */
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .clone-box {
    min-width: 75vw;
    padding: 1rem;

    h2 {
      text-align: center;
      font-weight: 700;
    }

    table {
      width: 100%;
    }

    td, th {
      padding: .5rem;
    }

    th {
      text-align: right;
      width: 30%;
    }

    table input {
      background-color: white;
      border-radius: 50rem;
      padding-left: .5rem;
      padding-right: .5rem;
      width: 100%;
      font-size: 1rem;
      font-weight: 400;
    }
  }

  .modal {
    display: none;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
    z-index: 9999;
  }

  .modal-content {
    background-color: #fefefe;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;

    h2 {
      text-align: center;
    }
  }

  .appInfo-table {
    table {
      width: 100%;
    }

    td, th {
      padding: .5rem;
    }

    th {
      text-align: right;
      width: 30%;
    }
  }

  .questionInfo-table {
    width: 100%;

    th {
      width: auto;
    }

    td, th {
      padding: .25rem;
      border: solid black 1px;
    }
  }

  .accordion {
    width: 100%;
    transition: 0.4s;
  }

  .active {
    background-color: globalSharedVariables.$brand-400;
  }

  .accordion:after {
    content: '\002B';
    color: #777;
    font-weight: bold;
    float: right;
    margin-left: 5px;
  }

  .active:after {
    content: "\2212";
  }

  .panel {
    padding: 0 18px;
    background-color: white;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
  }

</style>